<!-- Edit Course Page -->
<div class="container content-box" *ngIf="currentCourse && currentModule && page">
    <div class="flex">
      <!-- Back -->
      <app-close-button class="pull-right" (click)="goBack()" size="2x"></app-close-button>

      <!-- Title -->
      <h1 class="text-center">{{viewTitle}}</h1>
    </div>

    <!-- Update Form -->
    <form name="form" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate [class.disabled]="submitting">
        <fieldset [disabled]="submitting">

            <!-- Page Fields -->
            <div class="col-md-12">

                <!-- Course -->
                <div class="row mt-2">
                  <div class="col-md-12 mt-2"><label>Course:</label><input type="text" class="form-control" name="course" [(ngModel)]="page.course" readonly></div>
                </div>

                <!-- Module -->
                <div class="row mt-2">
                  <div class="col-md-12 mt-2"><label>Module:</label><input type="text" class="form-control" name="module" [(ngModel)]="page.module" readonly></div>
                </div>

                <!-- Page Title -->
                <div class="row mt-2">
                    <div class="col-md-12 mt-2">
                      <label>Page Title:</label>
                      <input type="text" class="form-control" name="title" [(ngModel)]="page.title" #title="ngModel" [ngClass]="{ 'is-invalid': f.submitted && title.invalid }" name="title" autofocus>
                    </div>
                </div>

                <!-- Page Type -->
                <div class="row mt-2">
                  <div class="col-md-12 mt-2">
                    <label class="required-field">Page Type</label>
                    <select name="pageType" id="pageType" class="form-control mb-2" [(ngModel)]="page.type" (ngModelChange)="onPageTypeSelected($event)" name="pageType" #pageType="ngModel" [ngClass]="{ 'is-invalid': f.submitted && pageType.invalid }" required>
                      <option value="" selected="selected" disabled="disabled">-- select one --</option>
                      <option [value]="type" *ngFor="let type of pageTypes">{{type}}</option>
                    </select>

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && pageType.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="pageType.errors!.required">Page type is required</div>
                    </div>
                  </div>
                </div>

                <!-- Custom Page Content -->
                <div class="row mt-2" [hidden]="page.type !== 'Custom'">
                  <div class="col-md-12 mt-2">
                    <label class="required-field">Content</label>
                    <editor
                      name="content" [ngModel]="page.content" (ngModelChange)="onContentChange($event)" #content="ngModel" [ngClass]="{ 'is-invalid': f.submitted && content.invalid }"
                      [init]="{
                        plugins: 'lists link media image table help fullscreen',

                        toolbar1:
                          'undo redo | bold italic underline strikethrough | fontfamily fontsize | forecolor backcolor | removeformat',
                        toolbar2:
                          'alignleft aligncenter alignright alignjustify | outdent indent | bullist numlist checklist | insertfile image media link | table | fullscreen | help',
                        table_toolbar:
                          'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',

                        base_url: '/assets/tinymce',
                        suffix: '.min',

                        height: 500,
                        menubar: false,

                        setup: editorSetup,
                        content_style: editorStyles,
                        font_family_formats: editorFonts
                      }"></editor>

                      <section class="source-code">
                        <a href (click)="toggleSourceCode($event)" class="toggle my-3">
                          <label>Source Code</label>
                          <mdb-icon class="ml-1" fas icon="chevron-right" [class.rotated]="editorCodeExpanded"></mdb-icon>
                        </a>

                        <textarea class="d-block form-control w-100" rows="12" *ngIf="editorInitialized && editorCodeExpanded" [(ngModel)]="page.content" [ngModelOptions]="{standalone: true}"></textarea>
                      </section>
                    </div>
                </div>

                <!-- Pre-Built Page Instance -->
                <div class="row mt-2" *ngIf="page.type && page.type !== 'Custom'">
                  <div class="col-md-12 mt-2">
                    <label class="required-field">Page Instance</label>
                    <select name="pageInstance" id="pageInstance" class="form-control mb-2" [(ngModel)]="page.instance" name="pageInstance" #pageInstance="ngModel" [ngClass]="{ 'is-invalid': f.submitted && pageInstance.invalid }" required>
                      <option value="" selected="selected" disabled="disabled">-- select one --</option>
                      <option [value]="instance" *ngFor="let instance of pageInstances">{{instance}}</option>
                    </select>

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && pageInstance.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="pageInstance.errors!.required">Page instance is required</div>
                    </div>
                  </div>
                </div>
            </div>
        </fieldset>

        <!-- Buttons -->
        <div class="buttons mt-4 text-center">

            <!-- Back -->
            <button type="button" class="btn waves-dark" (click)="onBack()">Back to List</button>

            <!-- Update -->
            <button type="submit" class="btn waves-dark" [disabled]="submitting">{{isNew ? 'Create' : 'Update'}}</button>

        </div>
    </form>
</div>
